import { useEffect, useRef } from 'react';

/**
 * Custom hook to handle clicking outside of a referenced element
 * @param {Function} handler - Function to call when clicking outside
 * @param {boolean} isActive - Whether the hook should be active
 * @returns {Object} ref - Ref to attach to the element
 */
export const useClickOutside = (handler, isActive = true) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!isActive) return;

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler();
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [handler, isActive]);

  return ref;
};

export default useClickOutside;
